import { render, staticRenderFns } from "./proyectos-e-ingenieria.vue?vue&type=template&id=5a002a0e&lang=html"
import script from "./proyectos-e-ingenieria.vue?vue&type=script&lang=js"
export * from "./proyectos-e-ingenieria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports